import { render, staticRenderFns } from "./FormatDetail.vue?vue&type=template&id=e170c9ca&scoped=true"
import script from "./FormatDetail.vue?vue&type=script&lang=js"
export * from "./FormatDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e170c9ca",
  null
  
)

export default component.exports